export const headerRows = [
  "Assumptions", 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030
]

export const bodyRows = [
  {
    title: "Rental Revenue",
    childRows: [
      {
        childTitle: "Potential Rental Revenue",
        assumptions: "$2/Sqft",
      },
      {
        childTitle: "Economic Vacancy",
        assumptions: "6%",
      },
      {
        childTitle: "Physical Vacancy",
        assumptions: "10%",
      },
      {
        childTitle: "Effective Gross Rental Revenue",
        assumptions: "$2/Sqft"
      }
    ]
  },
  {
    title: "empty",
    childRows: [
      {
        childTitle: "Total Termination Income",
        assumptions: "$15,000",
      },
      {
        childTitle: "Total Late Fees",
        assumptions: "$2,000"
      },
      {
        childTitle: "Total Parking and Others",
        assumptions: "$10,000",
      },
      {
        childTitle: "Other revenues from services provided in property",
        assumptions: "$8,000"
      },
      {
        childTitle: "Total Rental Revenues - Annual growth",
        assumptions: "2%/year"
      },
      {
        childTitle: "Total Rental Revenues",
        assumptions: "$560,000"
      }
    ]
  },
  {
    title: "Rental operating expenses",
    childRows: [
      {
        childTitle: "Property Taxes",
        assumptions: "$12,000",
      },
      {
        childTitle: "Insurance (Total)",
        assumptions: "$4,000",
      },
      {
        childTitle: "Repairs and Maintenance (Total)",
        assumptions: "$8,000",
      },
      {
        childTitle: "Property Management Fees",
        assumptions: "$6,000",
      },
      {
        childTitle: "Advertising (Total)",
        assumptions: "$2,000",
      },
      {
        childTitle: "Payroll and benefirst (Total)",
        assumptions: "$20,000",
      },
      {
        childTitle: "Office Supplies (Total)",
        assumptions: "$1,500",
      },
      {
        childTitle: "Phone & Internet (Total)",
        assumptions: "$1,500",
      },
      {
        childTitle: "Electricity",
        assumptions: "$6,000"
      },
      {
        childTitle: "Gas",
        assumptions: "$3,000",
      },
      {
        childTitle: "Other utilities",
        assumptions: "$2,000",
      },
      {
        childTitle: "Professional Services (Total)",
        assumptions: "$3,000",
      },
      {
        childTitle: "Misc Expenses (Total)",
        assumptions: "$1,000",
      },
      {
        childTitle: "Total Rental Operating Expenses - Annual growth",
        assumptions: "3%"
      },
      {
        childTitle: "Total Rental Operating Expenses",
        assumptions: "$71,070"
      }
    ]
  },
  {
    title: "Power revenues",
    childRows: [
      {
        childTitle: "Trading",
        assumptions: "$5,000",
      },
      {
        childTitle: "Batteries (Total)",
        assumptions: "$4,000"
      },
      {
        childTitle: "EV Charging (Total)",
        assumptions: "$2,000",
      },
      {
        childTitle: "Solar (Total)",
        assumptions: "$3,000",
      },
      {
        childTitle: "Power Assets Type.1 (Total)",
        assumptions: "$1,000",
      },
      {
        childTitle: "Total Power Revenue",
        assumptions: "$15,000",
      },
    ]
  },
  {
    title: "Power operating expenses",
    childRows: [
      {
        childTitle: "Fees",
        assumptions: "$500",
      },
      {
        childTitle: "Management Fees",
        assumptions: "$2,000",
      },
      {
        childTitle: "Total Power Operating Expenses",
        assumptions: "$2,500"
      }
    ]
  },
  {
    title: "Net Operating Income (NOI)",
    assumptions: "$47,810"
  },
  {
    title: "Debt Service",
    assumptions: "$30,000",
  },
  {
    title: "Cash Flow Before Taxes",
    assumptions: "$17,810"
  }
]
